import React from 'react';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

const TOTAL_AMOUNT_PROVINCES = 12;

const VolunteerWorkSearchResultItem = ({ item }) => {
  const { t } = useTranslation();
  const title = item.fields.title[0];
  const provinces = item.fields.provinces;
  let locationString = provinces.map((province) => t(`provinces.${province}`)).join(', ');

  if (provinces.length === TOTAL_AMOUNT_PROVINCES) {
    locationString = t('whole_country');
  }

  const city = item.fields.city && item.fields.city[0];

  if (city) {
    locationString = `${city}, ${locationString}`;
  }

  const phone = item.fields.phone && item.fields.phone[0];
  const website = item.fields.website && item.fields.website[0];

  return (
    <div className="VolunteerWorkResultItem">
      <div className="VolunteerWorkResultItem__title">
        <span className="VolunteerWorkResultItem__title__name">{title}</span>
        <div className="VolunteerWorkResultItem__title__location">
          <i className="icon icon-marker icon-variant-2" />
          <span>{locationString}</span>
        </div>
      </div>
      <div className="VolunteerWorkResultItem__contact">
        {phone && (
          <CoreLink className="VolunteerWorkResultItem__contact__phone" href={`tel:${phone}`}>
            <span className="VolunteerWorkResultItem__contact__phone__label">{t('call')}</span>
            <i className="icon icon-phone icon-variant-1" /> <span className="VolunteerWorkResultItem__contact__phone__full">{phone}</span>
          </CoreLink>
        )}
        {website && (
          <CoreLink className="VolunteerWorkResultItem__contact__website" href={website}>
            <span className="VolunteerWorkResultItem__contact__website__full">{t('to')} {new URL(website).host.replace(/www\./, '')}</span>
            <span className="VolunteerWorkResultItem__contact__website__label">{t('website')}</span>
            <i className="icon icon-arrow-right icon-variant-1" />
          </CoreLink>
        )}
      </div>
    </div>
  );
};

export default VolunteerWorkSearchResultItem;
